export const PRIVACY_NOTICE = 'Privacy Notice';